exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "/* App Colors\n------------------------------------------------------------ */\n.letter-container {\n  display: -ms-flexbox;\n  display: flex;\n  -ms-flex-direction: row-reverse;\n      flex-direction: row-reverse;\n  width: 100%;\n  margin: 0; }\n\n.letter {\n  -ms-flex: 1;\n      flex: 1;\n  margin: 0;\n  padding: 0;\n  font-size: 26px;\n  line-height: 24px;\n  text-align: center; }\n  .letter > span {\n    position: relative;\n    top: -3px; }\n\n.letter:hover {\n  cursor: pointer; }\n\n.is-active {\n  background: #0076ff;\n  color: #ffffff; }\n", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// E:/Projects/HaMafteach/HaMafteach Comprehensive/online-database/web-client/src/app/admin-area/containers/hebrew-pager/hebrew-pager.component.scss
// module id = ../../../../../src/app/admin-area/containers/hebrew-pager/hebrew-pager.component.scss
// module chunks = main